import React from "react";
import { useSearchParams } from "react-router-dom";

import { CatalogStore, FilterStore, ConfigurationStore } from "stores";

interface IPipeline {
  type: string;
  defaultValue: any;
  Component: any;
  Reducer: any;
  Indicator: any;
}

const Pipeline: React.FC<IPipeline> = ({
  type,
  defaultValue,
  Component,
  Reducer,
  Indicator,
}) => {
  const {
    state: { entities },
  } = React.useContext(CatalogStore);
  const configuration = React.useContext(ConfigurationStore);
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    state: {
      filter: { [type]: value },
    },
    dispatch: dispatchFilter,
  } = React.useContext(FilterStore);

  const dispatchFilterAndLink = ({ type, payload }: any) => {
    switch (type) {
      case "UPDATE_FILTER": {
        const [[type, newValue]] = Object.entries(payload);
        if (Array.isArray(newValue)) {
          if (newValue.length === 0) {
            searchParams.delete(type);
          } else {
            searchParams.set(type, newValue.toString());
          }
        } else if (newValue === null) {
          searchParams.delete(type);
        }
        setSearchParams(searchParams);
        break;
      }
    }
    dispatchFilter({ type, payload });
  };

  React.useEffect(
    () => {
      dispatchFilter({
        type: "ADD_REDUCER",
        payload: { key: type, value: Reducer },
      });
      dispatchFilter({
        type: "ADD_INDICATOR",
        payload: { key: type, value: Indicator },
      });
      if (value) return;
      const params = searchParams.get(type);
      if (params) {
        const value = params.split(",").map((e) => parseInt(e));
        dispatchFilter({
          type: "INIT_FILTER",
          payload: {
            value: { [type]: value },
            reset: { [type]: defaultValue },
          },
        });
      } else {
        dispatchFilter({
          type: "INIT_FILTER",
          payload: {
            value: { [type]: defaultValue },
            reset: { [type]: defaultValue },
          },
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  if (!entities) return null;

  return (
    <Component
      {...{
        entities,
        value,
        configuration,
        dispatchFilter: dispatchFilterAndLink,
      }}
    />
  );
};

export default Pipeline;
